// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__J9+58","load":"Spinner_load__l7lq9"};